




























import Vue from 'vue';
import Component from 'vue-class-component';
import TextInput from '@/components/TextInput.vue';
import { mapModelLike } from '@/store/util';

@Component({
  components: { TextInput },
  computed: mapModelLike('lifestyle', ['primaryLifestyle', 'nuyen', 'idsAndLicenses']),
})
export default class LifestyleBox extends Vue {
  static defaultHeight = 6;
}
